<template>
  <div>
    <h3>{{ tituloFormulario }}</h3>
    <v-tabs
      v-model="indiceAba"
      class="abas-padrao"
      background-color="primary"
      color="primary"
      @change="salvarAoMudar"
    >
      <v-tab>
        {{ $t('modulos.mensagem_orcamento.tab.mensagem_orcamento') }}
      </v-tab>
      <v-tab :disabled="form.obrigatorio !== 'ConformeCriterios'">
        {{ $t('modulos.mensagem_orcamento.tab.criterios') }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="indiceAba">
      <v-tab-item>
        <div class="mt-3">
          <v-form ref="form" class="row">
            <input-text
              v-model="form.titulo"
              class="col-12 col-md-4"
              :label="$t('modulos.mensagem_orcamento.formulario.titulo')"
              :placeholder="
                $t('modulos.mensagem_orcamento.formulario.titulo_placeholder')
              "
              :max="200"
              obrigatorio
              trim
            />
            <input-select
              v-model="form.classificacao"
              :options="opcoes.classificacao"
              class="col-12 col-md-4"
              :label="$t('modulos.mensagem_orcamento.formulario.classificacao')"
              obrigatorio
            />
            <input-select
              v-model="form.obrigatorio"
              :options="opcoes.boleano"
              class="col-12 col-md-4"
              :label="$t('modulos.mensagem_orcamento.formulario.obrigatorio')"
            />
            <input-textarea
              v-model="form.descricao"
              class="col-12"
              :label="$t('modulos.mensagem_orcamento.formulario.descricao')"
              :placeholder="
                $t(
                  'modulos.mensagem_orcamento.formulario.descricao_placeholder'
                )
              "
              :max="5000"
              obrigatorio
              trim
            />
          </v-form>
          <v-divider class="my-5" />
          <div class="d-flex align-center justify-end">
            <botao-padrao
              outlined
              color="secondary"
              class="mr-2"
              @click="cancelar"
            >
              <v-icon>$mdiCancel</v-icon>
              {{ $t('geral.botoes.cancelar') }}
            </botao-padrao>
            <botao-padrao
              :title="
                getErros.length > 0 && form.obrigatorio === 'ConformeCriterios'
                  ? 'É necessário adicionar mensagens conforme critérios'
                  : ''
              "
              :disabled="
                getErros.length > 0 && form.obrigatorio === 'ConformeCriterios'
              "
              @click="confirmacaoSalvar"
            >
              <v-icon>$mdiContentSaveOutline</v-icon>
              {{ $t('geral.botoes.salvar') }}
            </botao-padrao>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="mt-3">
          <criterios :criterios="form.criterios" @submit-criterios="salvar" />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import MensagemOrcamentoService from '@common/services/cadastros/MensagemOrcamentoService';
import EnumeradorService from '@common/services/cadastros/EnumeradorService';
import { MensagemOrcamentoModel } from '@common/models/cadastros/MensagemOrcamentoModel';
import helpers from '@/common/utils/helpers';
import Criterios from './criterios';
import { mapGetters } from 'vuex/dist/vuex.common.js';

export default {
  components: {
    Criterios,
  },
  props: ['id'],
  data() {
    return {
      valido: false,
      form: new MensagemOrcamentoModel({}),
      opcoes: {
        classificacao: [],
        boleano: [
          ...helpers.BoleanoEnum,
          {
            text: 'Conforme critérios',
            value: 'ConformeCriterios',
            cor: 'primary-error-700',
          },
        ],
      },
      indiceAba: 0,
      indiceAbaAtual: 0,
      abasLiberadas: {
        tabelas: false,
        valores: false,
      },
    };
  },
  computed: {
    ...mapGetters('criterios', ['getCriterios', 'getErros']),
    tituloFormulario: function () {
      if (this.id) return this.$t('modulos.mensagem_orcamento.titulos.editar');
      return this.$t('modulos.mensagem_orcamento.titulos.novo');
    },
  },
  mounted() {
    if (this.id) {
      this.buscar(this.id);
      helpers.redirecionarSemPermissao(this, 'Mensagem', 'Editar');
    } else {
      helpers.redirecionarSemPermissao(this, 'Mensagem', 'Inserir');
      this.$store.dispatch('criterios/addCriterio', {
        newCriterio: [
          {
            id: '',
            sequencia: 1,
            operadorLogico: null,
            tipoCriterio: null,
            operadorRelacional: 'Igual',
            tipoOrcamento: null,
            tipoContrato: null,
            valorTotalOrcamento: null,
            requisitoParticipante: null,
            servicoCalibracao: {
              id: null,
              codigo: null,
            },
            tipoCalibracao: {
              id: null,
              nome: null,
              apelido: null,
            },
            servicoManutencao: undefined,
            item: {
              id: null,
              descricao: null,
            },
            localExecucao: {
              id: null,
              nome: null,
            },
            participanteConta: {
              id: null,
              nome: null,
              apelido: null,
            },
            tipoInstrumento: {
              id: null,
              nome: null,
            },
            campoAdicionalInstrumento: {
              id: null,
              nome: null,
            },
            campoAdicionalParticipante: {
              id: null,
              nome: null,
            },
          },
        ],
      });
    }

    this.form.criterios = this.$store.getters['criterios/getCriterios'];
    this.$store.dispatch('Layout/alterarTituloPagina', this.tituloFormulario);
    this.buscarClassificacao();
  },
  methods: {
    salvarAoMudar: function () {},
    buscar: function () {
      this.$store.dispatch('Layout/iniciarCarregamento');
      MensagemOrcamentoService.buscar(this.id)
        .then((res) => {
          this.form = new MensagemOrcamentoModel(res.data);
          this.$store.dispatch('criterios/addCriterio', {
            newCriterio: this.form.criterios,
          });
          this.valido = true;
        })
        .catch(() => {
          this.toastErro(
            this.$t('modulos.mensagem_orcamento.erros.id_invalido')
          );
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
          this.valido = this.$refs.form.validate();
        });
    },
    confirmacaoSalvar: function () {
      if (!this.id) {
        this.salvar();
        return;
      }
      this.confirmarSalvar().then(() => {
        this.salvar();
      });
    },
    preparaLinhasCriterio: function () {
      let criterios = this.$store.getters['criterios/getCriterios'];
      const tiposCriterioMap = {
        servicoCalibracao: 'Serviço de Calibração',
        servicoCalibracaoTipoCalibracao:
          'Serviço de Calibração com Tipo de Calibração',
        servicoCalibracaoContratoTipoContrato:
          'Serviço de Calibração em Contrato com Tipo de Contrato',
        servicoManutencao: 'Serviço de Manutenção',
        peca: 'Peça',
        localExecucao: 'Local de execução',
        participanteConta: 'Participante da conta',
        valorTotalOrcamento: 'Valor total do orçamento',
        tipoOrcamento: 'Tipo de Orçamento',
        tipoInstrumento: 'Tipo de Instrumento',
        campoAdicionalInstrumento: 'Campo adicional do Instrumento',
        campoAdicionalParticipante: 'Campo adicional do Participante',
        requisitoParticipante: 'Requisito do Participante',
      };

      criterios.map((e) => {
        e.tipoCriterio = Object.keys(tiposCriterioMap).find(
          (key) => tiposCriterioMap[key] === e.tipoCriterio
        );
        return e;
      });

      return criterios;
    },
    adaptarCriterio() {
      let criterios = this.$store.getters['criterios/getCriterios'];

      let criteriosAdaptados = criterios.map((criterio) => {
        let criterioAdaptado = {
          sequencia: criterio.sequencia ?? 1,
          operadorLogico: criterio.operadorLogico,
          tipoCriterio: criterio.tipoCriterio,
          operadorRelacional: criterio.operadorRelacional,
          valor: criterio.valor,
        };

        switch (criterio.tipoCriterio) {
          case 'CampoAdicionalInstrumento':
            criterioAdaptado.campoAdicionalInstrumentoId =
              criterio.campoAdicionalInstrumentoId ||
              criterio.campoAdicionalInstrumento.id;
            return criterioAdaptado;
          case 'CampoAdicionalParticipante':
            criterioAdaptado.campoAdicionalParticipanteId =
              criterio.campoAdicionalParticipanteId ||
              criterio.campoAdicionalParticipante.id;
            return criterioAdaptado;
          case 'ServicoCalibracao':
            criterioAdaptado.servicoCalibracaoId =
              criterio.servicoCalibracaoId || criterio.servicoCalibracao.id;
            criterioAdaptado.servicoCalibracao = criterio.servicoCalibracao;
            return criterioAdaptado;
          case 'ServicoManutencao':
            criterioAdaptado.servicoManutencaoId = criterio.servicoManutencaoId;
            criterioAdaptado.servicoManutencao = criterio.servicoManutencao;
            return criterioAdaptado;
          case 'TipoCalibracao':
            criterioAdaptado.tipoCalibracaoId = criterio.tipoCalibracaoId;
            return criterioAdaptado;
          case 'ParticipanteConta':
            criterioAdaptado.participanteContaId = criterio.participanteContaId;
            return criterioAdaptado;
          case 'TipoContrato':
            criterioAdaptado.tipoContrato = criterio.tipoContrato;
            criterioAdaptado.valor = criterio.valor;
            return criterioAdaptado;
          case 'Item':
            criterioAdaptado.item = criterio.item;
            criterioAdaptado.itemId = criterio.item.id;
            return criterioAdaptado;
          case 'RequisitoParticipante':
            criterioAdaptado.requisitoParticipante = criterio.valor;
            criterioAdaptado.valor = criterio.valor;
            return criterioAdaptado;
          case 'ValorTotalOrcamento':
            criterioAdaptado.valorTotalOrcamento = criterio.valorTotalOrcamento;
            return criterioAdaptado;
          case 'LocalExecucao':
            criterioAdaptado.localExecucaoId = criterio.localExecucaoId;
            criterioAdaptado.localExecucao = criterio.localExecucao;
            return criterioAdaptado;
          case 'TipoOrcamento':
            criterioAdaptado.tipoOrcamento = criterio.tipoOrcamento;
            return criterioAdaptado;
          case 'TipoInstrumento':
            criterioAdaptado.tipoInstrumentoId =
              criterio.tipoInstrumentoId || criterio.tipoInstrumento.id;
            criterioAdaptado.tipoInstrumento = criterio.tipoInstrumento;
            return criterioAdaptado;
          default:
            'RequisitoParticipante';
            console.warn(
              `Tipo de critério não reconhecido: ${criterio.tipoCriterio}`
            );
            return criterio;
        }
      });
      return criteriosAdaptados;
    },
    adapterForm(dados) {
      if (this.form.obrigatorio != 'ConformeCriterios') {
        return (this.form = {
          id: this.form.id,
          titulo: this.form.titulo,
          descricao: this.form.descricao,
          classificacao: this.form.classificacao,
          sequencia: this.form.sequencia,
          obrigatorio:
            typeof dados.obrigatorio === 'boolean'
              ? dados.obrigatorio
                ? 'Sim'
                : 'Nao'
              : dados.obrigatorio,
          criterios: [],
        });
      } else {
        return {
          id: dados.id,
          titulo: dados.titulo,
          descricao: dados.descricao,
          classificacao: dados.classificacao,
          sequencia: dados.sequencia,
          obrigatorio:
            typeof dados.obrigatorio === 'boolean'
              ? dados.obrigatorio
                ? 'Sim'
                : 'Nao'
              : dados.obrigatorio,
          criterios: dados.criterios ?? [],
        };
      }
    },
    salvar: function () {
      this.form.criterios = this.adaptarCriterio() || [];
      this.form = this.adapterForm(this.form);

      if (this.$refs.form) {
        this.valido = this.$refs.form.validate();
        this.indiceAba = 0;
      }

      if (!this.valido) return;
      this.$store.dispatch('Layout/iniciarCarregamento');

      MensagemOrcamentoService.salvar(this.form)
        .then(() => {
          this.$router.push({ name: 'mensagem-orcamento' });
          this.toastSucesso(
            this.$t(`modulos.mensagem_orcamento.cadastro_sucesso`)
          );
        })
        .catch((err) => {
          this.toastErro(this.$t(`geral.erros.${err.response.data.errors[0]}`));
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    cancelar: function () {
      this.confirmarCancelar().then(() => {
        this.$router.push({ name: 'mensagem-orcamento' });
      });
    },
    buscarClassificacao: function () {
      EnumeradorService.buscar('EnumMensagemClassificacao').then((res) => {
        this.opcoes.classificacao = res;
      });
    },
  },
};
</script>
